import { render, staticRenderFns } from "./AttorneyCommonTable.vue?vue&type=template&id=00fb8622&"
import script from "./AttorneyCommonTable.vue?vue&type=script&lang=js&"
export * from "./AttorneyCommonTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports